import { ScanEye } from 'lucide-react'
import { ControllerRenderProps } from 'react-hook-form'

import { InputAddressExtensionForm, UseInputAddressExtensionResult } from '@/domain/hooks/useInputAddressExtension'
import { Button } from '@/ui/atoms/button/Button'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { Form } from '@/ui/atoms/form/Form'
import { AddressInput } from '@/ui/molecules/address-input/AddressInput'
import { testIds } from '@/ui/utils/testIds'

export interface WatchWalletDialogViewProps {
  inputAddressExtension: UseInputAddressExtensionResult
  field: ControllerRenderProps<InputAddressExtensionForm, 'address'>
  enableWatchWalletMode: () => void
}

export function WatchWalletDialogView({
  field,
  inputAddressExtension,
  enableWatchWalletMode,
}: WatchWalletDialogViewProps) {
  return (
    <div className="flex flex-col gap-5">
      <DialogTitle className="typography-heading-5 flex items-center gap-2 py-2 md:p-0">
        <ScanEye className="icon-size-sm text-secondary" />
        Watch Wallet
      </DialogTitle>
      <p className="typography-body-2 text-secondary">
        Watch Wallet mode lets you view another wallet exactly as if it were your own. You can browse all positions and
        data, but you won't be able to perform any actions or interact with the app.
      </p>
      <Form {...inputAddressExtension.form}>
        <AddressInput
          {...field}
          label="Wallet to watch"
          placeholder="Address"
          error={inputAddressExtension.form.formState.errors.address?.message}
        />
      </Form>
      <Button
        onClick={enableWatchWalletMode}
        size="l"
        disabled={!inputAddressExtension.form.formState.isValid}
        data-testid={testIds.dialog.watchWallet.enableButton}
      >
        Enable
      </Button>
    </div>
  )
}
